import React, {useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navigation from './main-js/Navigation'; // Import the Navigation if you want to have a global nav (optional)
import MainContent from './main-js/MainContent';
import LoginPopUp from './main-js/login-js/LoginPopUp';
import ProfilePage from './main-js/login-js/ProfilePage';
import ChatbotPage from './main-js/chatbox-js/ChatbotPage'; 
import NewsPage from './main-js/news-js/NewsPage';
import ShopPage from './main-js/shop-js/ShopPage';
import ResetPassword from './main-js/login-js/ResetPasswordPage';
import EmailVerificationPage from './main-js/login-js/EmailVerificationPage';
import NotFoundPage from './main-js/NotFoundPage'; // This will be your 404 page


const App = () => {
  return (
    <div>
      <Router>
        <AppWithRouter />
      </Router>
    </div>
  );
};

const AppWithRouter = () => {
  const location = useLocation(); // Get the current location/path
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  console.log(location.pathname); // This will log the current URL path

  return (
    <div>
      <div className="app">
        {/* Optional: Add Navigation */}
        {location.pathname !== '/' && <Navigation />} {/* Only render Navigation if not on the home page */}

        <div className="content">
          <Routes>
            {/* Default Home Page Route */}
            <Route path="/" element={<><MainContent /></>} />

            {/* Chatbot Route */}
            <Route path="/chat" element={<ChatbotPage />} />

            {/* Login Route */}
            <Route path="/valid/login" element={<LoginPopUp />} />

            {/* Pass Reset*/}
            <Route path="/reset-password" element={<ResetPassword token={token} />} />

            {/* Verify Email*/}
            <Route path="/verify-email" element={<EmailVerificationPage token={token} />} />

            {/* News Route */}
            <Route path="/news" element={<NewsPage />} />

            {/* Shop Route */}
            <Route path="/shop" element={<ShopPage />} />

            {/* Profile Route */}
            <Route path="/valid/profile" element={<ProfilePage />} />

            {/* Catch-all Route for 404 (if no route matches) */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default App;